"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var p4_css_1 = require("p4-css");
exports.railHeight = 8;
var railClass = p4_css_1.rule({
    d: 'flex',
    w: '100%',
    h: exports.railHeight + 'px',
    pos: 'relative',
    bdrad: '2px',
    ov: 'hidden',
});
exports.RailWrap = function (_a) {
    var children = _a.children;
    return React.createElement("span", { className: railClass }, children);
};
